import SecureEndpoint from './secure-endpoint'
import PublicEndpoint from './public-endpoint'
import { AxiosResponse } from 'axios'
import { TResponseType } from '../models'

const read = (payload: { id: string }): Promise<AxiosResponse<TResponseType>> => {
  return SecureEndpoint().get('/api/v1/accounts/' + payload.id)
}

const remove = (payload: { id: string }): Promise<AxiosResponse<TResponseType>> => {
  return SecureEndpoint().delete('/api/v1/accounts/' + payload.id)
}

const add = (payload: unknown): Promise<AxiosResponse<TResponseType>> => {
  return SecureEndpoint().post('/api/v1/accounts', payload)
}

const signup = (payload: unknown): Promise<AxiosResponse<TResponseType>> => {
  return PublicEndpoint().post('/api/v1/accounts/signup', payload)
}

const update = (payload: { id: string }): Promise<AxiosResponse<TResponseType>> => {
  return SecureEndpoint().put(`/api/v1/accounts/${payload.id}`, payload)
}

const updateMFA = (payload: { id: string; useMFA: boolean }): Promise<AxiosResponse<TResponseType>> => {
  return SecureEndpoint().post(`/api/v1/accounts/${payload.id}/changemfa`, { useMFA: payload.useMFA })
}

const reinvite = (payload: { id: string }): Promise<AxiosResponse<TResponseType>> => {
  return SecureEndpoint().post(`/api/v1/accounts/${payload.id}/reinvite`, payload)
}

const userInfo = (): Promise<AxiosResponse<TResponseType>> => {
  return SecureEndpoint().get(`/api/v1/accounts/userinfo/me`)
}

const checkUsername = (username: string): Promise<AxiosResponse<TResponseType>> => {
  return PublicEndpoint().get(`/api/v1/accounts/username/check`, { params: { username } })
}

const suggestUsername = (params: {
  username?: string
  firstName?: string
  lastName?: string
}): Promise<AxiosResponse<TResponseType>> => {
  return PublicEndpoint().get(`/api/v1/accounts/username/suggest`, { params })
}

export const accountService = {
  read,
  remove,
  add,
  signup,
  update,
  reinvite,
  userInfo,
  updateMFA,
  checkUsername,
  suggestUsername,
}
